export const getAfyaImaraState = (state) => state?.afyaImara;
